












































































import { defineComponent, toRefs, computed } from '@vue/composition-api';
import { ChevronRightIcon } from 'tdesign-icons-vue';
import i18n, { i18n_t } from '@/locales/i18n';
import registerHandler from '@/renderer/components/user/compositions/registerHandler';

// 引入工具类
import { channelEditionMap, getChannel } from '@/renderer/scripts/composition/channel';
import { userRole } from '@/renderer/scripts/utils/ConstantConfig/ConstantI18NConfig';
import user from '@/renderer/scripts/utils/user';
import tips from '@/renderer/scripts/utils/tips';
export default defineComponent({
  components: {
    ChevronRightIcon,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    switching: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: [],
    },
    type: {
      type: String,
      default: 'login',
    },
  },
  filters: {
    formatRole(role: string): string {
      return userRole[role];
    },
  },
  setup(props, context) {
    const store = context.root.$store;
    const vm = context.root;
    const { list, type } = toRefs(props);
    const {
      creatingOrg,
      showCancelDeregiseterDialog,
      showFreezeDialog,
      showIPRestrictDialog,
      createOrgFn,
      register: registerFn,
    } = registerHandler();
    const { channelTag, channelName, channelIconClass } = getChannel();
    const methods = {
      // 格式化组织列表
      orgListFormat(organizations: CoFile.OrgItem[]): CoFile.FormattedOrgItem[] {
        store.commit('setChooseRole', true);
        const formattedOrgList = organizations.map((item: CoFile.OrgItem) => {
          // 默认企业版
          const editionFlag = item?.extensionData?.editionConfig?.editionFlag || 'enterprise';
          let editionType = '';
          if (editionFlag === 'enterprise') {
            editionType = i18n_t('企业版');
          } else if (editionFlag === 'team') {
            editionType = i18n_t('团队版');
          } else {
            editionType = i18n_t('个人版');
          }
          const channelFlag = item?.extensionData?.channelFlag || '';
          const channelNotUpdated = channelFlag && !item?.extensionData?.isUpdated;
          // 是否渠道体验版
          if (channelNotUpdated) {
            editionType = channelEditionMap[channelFlag] ? channelEditionMap[channelFlag] : editionType;
          }
          return {
            ...item,
            deregister: item?.orgUser?.deregister || false,
            enabled: item?.orgUser?.enabled,
            editionFlag,
            editionType,
            channel: channelNotUpdated ? channelFlag : '',
          };
        });

        // 只有再切换企业的时候进行比较
        if (type.value === 'switchOrg') {
          const lastLoginedOrg = formattedOrgList.find(item => item.isLastSignedIn);
          if (!lastLoginedOrg || !lastLoginedOrg.id) return formattedOrgList;

          // 如果判断list里面的当前登陆和现在所登陆的企业是不一样的，还是选择本地的优先
          if (lastLoginedOrg.id !== store.getters.orgId) {
            formattedOrgList.forEach(item => {
              if (item.id === lastLoginedOrg.id) {
                item.isLastSignedIn = false;
              } else if (item.id === store.getters.orgId) {
                item.isLastSignedIn = true;
              }
            });
            // 手动排序 上次登录的在前面
            return formattedOrgList.sort((a: any, b: any) => {
              if (a.isLastSignedIn && !b.isLastSignedIn) {
                return -1;
              }
              return 1;
            });
          }
        }
        return formattedOrgList;
      },
      // 选中企业
      submit(orgInfo: CoFile.OrgItem) {
        // 注销中
        if (orgInfo.deregister) {
          showCancelDeregiseterDialog(orgInfo.id, orgInfo.editionFlag, () => context.emit('submit', orgInfo));
          return;
        }
        // 冻结中
        if (!orgInfo.enabled) {
          const editionFlag = orgInfo?.extensionData?.editionConfig?.editionFlag || 'enterprise';
          showFreezeDialog(editionFlag);
          return;
        }
        if (orgInfo.ipLimitEnabled) {
          showIPRestrictDialog();
          return;
        }
        context.emit('submit', orgInfo);
      },
      // 注册个人版 【废弃】
      async register() {
        const registerData = await registerFn();
        if (registerData) {
          if (type.value === 'switchOrg') {
            tips.success(i18n_t('注册成功，即将切换到个人版'));
            setTimeout(() => {
              // 切换身份页，注册成功后自动切换到个人版
              user.setOrgAndLogin(registerData);
            }, 500);
          } else {
            // 登录页，注册成功后自动登录
            user.setOrgAndLogin(registerData);
          }
        }
      },
      // 创建渠道体验版
      async createOrg() {
        // 防止多次点击创建
        if (creatingOrg.value) return;
        tips.loading(i18n_t('正在创建，请稍后'), 0);
        const createResult = await createOrgFn(channelTag);
        if (!createResult) return;
        methods.submit(createResult as CoFile.OrgItem);
      },
    };
    const formattedList = computed(() => methods.orgListFormat(list.value as CoFile.OrgItem[]));

    // hiflow可用的企业列表是 企业版、体验版 && 非冻结 && 非过期 && 非注销
    const hiflowFormattedList = computed(() =>
      methods.orgListFormat(list.value as CoFile.OrgItem[]).filter(item => {
        const isEnterprise = item?.extensionData?.editionConfig?.editionFlag === 'enterprise';
        return isEnterprise && !item.expired && !item.orgUser?.deregister && item.orgUser?.enabled;
      }),
    );
    const orgList = computed(() => (channelTag === 'hiflow' ? hiflowFormattedList.value : formattedList.value));

    // 存在可用的非渠道企业版（hiflow里对应付费企业版，会议里付费版即可）
    const hasAvailableOrg = computed(
      () =>
        orgList.value.filter(item => {
          const orgAvailable = !item.expired && !item.orgUser?.deregister && item.orgUser?.enabled;
          // 渠道版
          const isChannel = item?.extensionData?.channelFlag && !item?.extensionData?.isUpdated;
          return !isChannel && orgAvailable;
        }).length > 0,
    );

    // 是否展示创建体验版入口：之前没有领取过 && 当前环境在渠道内 && 当前企业列表没有可以进入的付费企业版
    const showCreateOrgBtn = computed(
      () => !store.getters.hasAppliedChannelOrg && channelTag && !hasAvailableOrg.value,
    );

    // hiflow里必须企业列表有值 || 可领取体验版 才展示
    const showOrgList = computed(() => {
      if (channelTag !== 'hiflow') return true; // 非hiflow渠道全部需要展示
      if (channelTag === 'hiflow' && hiflowFormattedList.value.length > 0) return true;
      if (channelTag === 'hiflow' && showCreateOrgBtn.value) return true;
      return false;
    });
    return {
      orgList,
      showCreateOrgBtn,
      channelName,
      channelIconClass,
      showOrgList,
      ...methods,
    };
  },
});
